import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M16,2v4" }),
			/* @__PURE__ */ _jsx("path", { d: "M8,2v4" }),
			/* @__PURE__ */ _jsx("path", { d: "M3,9h18" }),
			/* @__PURE__ */ _jsx("path", { d: "M19,4h-14c-1.105,0 -2,0.895 -2,2v13c0,1.105 0.895,2 2,2h14c1.105,0 2,-0.895 2,-2v-13c0,-1.105 -0.895,-2 -2,-2Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M10.6,13.82l1.46,-1.32" }),
			/* @__PURE__ */ _jsx("path", { d: "M10.72,17.5h2.68" }),
			/* @__PURE__ */ _jsx("path", { d: "M12.06,12.5v5" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgCalendar1;
